//    App - the topmost instance of the webpage, under which all react based views and components are added

import * as React from "react";
import * as ClientOAuth2 from "client-oauth2";

import { Prislister } from "./prislister";
import { Prisliste } from "../viewmodel/prisliste";
import { ImageButton } from "./ImageButton";
import { ToolbarButton } from "./ToolbarButton";
import { OrientationButton } from "./OrientationButton";
import { TreeViewGW } from "./TreeViewGW";
import { BDKalkCore } from "./BDKalkCore"
import { PADebug } from "./PADebug"
import { ArticleViewGW } from "./ArticleViewGW";
import { SelectionViewGW } from "./SelectionViewGW";
import { ArticleGW } from "./ArticleGW";
import { ChoiseControlGW } from "./ChoiseControlGW";
import { TotalDisplayGW } from "./TotalDisplayGW";
import { ExtInfoViewGW } from "./ExtInfoViewGW";
import { ExtTabGW } from "./ExtTabGW";
import { QReportTitleGW } from "./QReportTitleGW";
import { QReportTabGW } from "./QReportTabGW";
import { LoadBarGW } from "./LoadBarGW";
import { ProjectView } from "./ProjectView";
import { ProjectSaveView } from "./ProjectSaveView";
import { BuildPartView } from "./BuildPartView";
import { BuildPartSaveView } from "./BuildPartSaveView";
import { NobbAlphaButton } from "./NobbAlphaButton";
import { BuildPartGW } from "./BuildPartGW";
import { SummaryView } from "./SummaryView";
import { SearchField } from "./SearchField";
import { SearchSettingsView } from "./SearchSettingsView";
import { MakeNational } from "./BDKalkCore"
import { PriceSettingsView } from "./PriceSettingsView";
import { NewProjectView } from "./NewProjectView";
import { HelpView } from "./HelpView";
import { LoadingView } from "./LoadingView";
import { FavoritesDeleteView } from "./FavoritesDeleteView";
import { CreationView } from "./CreationView";
import { ScrollToTopButton } from "./ScrollToTopButton";
import { LogView } from "./LogView";
import { GetAuto } from "./SearchSettingsView";

// GetFromUrl - for loading of json files
function GetFromUrl(url: string) {
    var Httpreq = new XMLHttpRequest(); // a new request
    Httpreq.open("GET", url, false);
    Httpreq.send(null);
    return Httpreq.responseText;
}

interface AppState {
    Status: Status
    Error?: string
    Pricelist?: Prisliste
    DisplayMode: number   // Possible values are enumerated in app.DMode
    ExtInfoUp: boolean
    selectionID: string // The ID string of either the selected article or the selected build part (only one can be selected)
    viewHeight: number
    articlesUrl: string,
    articlesNobb: string,
    resultTotalArticles:number,
    resultGroup: number, // The presently selected "page" of search results. For example resultGroup:2 means results between 50 (25*2) and 74 (25*2+(25-1))
    resultGroupStart: number, // This determines from what set of groups the sets will be displayed, for example if 10 and resultGroup is 12, buttons will go from 10 to 19 with 12 highlighted
    resultGroupRange: number, // This tells how many groups should be displayed at once when there are many, default is 10
    resultGroupLength: number, // The amount of articles that can be shown at once within a search result or other displaying of articles, the total amount divided into groups by this size
    cathegoricSearch: boolean, // If true then the last selected group will be a limitation to the searches, and this will be shown & changed from a button beside the seach field.
    initStage: number,
    accessToken?: ClientOAuth2.Token // Access token from the authentication server
}

enum Status {
    Ready,
    Waiting,
    Error
}

interface UserInfo {
    id: number,
    email: string,
    name: string,
    roleID:number
}

//  App - the top level of the page 
export class App extends React.Component<{}, AppState> {
    
    // DMode enumerates the possible values for the current DisplayMode, which tells what's going to be shown in the article Display window (right hand side)
    public DMode = {
        Init: 0,
        Loading: 1,
        QReport: 2,
        Settings: 3,
        SearchResult: 4,
        Favorites: 5,
        Url: 6,
        NobbGroup: 7,
        renderOrders: 8,
        projectLoad: 9,
        projectSave: 10,
        byggdelLoad: 11,
        byggdelSave: 12,
        searchSettings: 13,
        priceSettings: 14,
        newProject: 15,
        help: 16,
        FavoritesDelete: 17,
        creative: 18,
        log:19
    }

    state: AppState = {
        Status: Status.Waiting,
        Pricelist: {
            Tittel: "ingen valgt (demo)"
        },
        DisplayMode: this.DMode.Init,
        ExtInfoUp: false,
        selectionID: "(no selection made yet)",
        viewHeight: -1,
        articlesUrl: "",
        articlesNobb: "",
        resultTotalArticles: 0,
        resultGroup: 0,
        resultGroupStart: 0,
        resultGroupRange: 10,
        resultGroupLength: GetAuto(),
        cathegoricSearch: true,
        initStage: 0
    }

    // a reference to the core (it will be initiated on construction)
    private m_core: BDKalkCore
    private m_searchInput: HTMLInputElement  // A handle to the input object
    private m_recentSearchInput: string
    private m_auth: ClientOAuth2 // OAuth2 authentication client
    public ServerUrl: string
    private IdServerUrl: string

    OnResize(e: UIEvent) {
        if (this.state.DisplayMode == this.DMode.searchSettings) {
            var sv = this.m_core.GetSearchSettingsView()
            if (sv) {
                sv.forceUpdate()
            }
        }
    }

    constructor(props: {}) {
        super(props);
        this.ServerUrl = process.env.PRISASSISTENTEN_API_BASE_URL!;
        this.IdServerUrl = process.env.PRISASSISTENTEN_BDID_URL!;
        this.m_auth = new ClientOAuth2({
            clientId: 'bdkalk',
            accessTokenUri: this.IdServerUrl + 'connect/access_token',
            authorizationUri: this.IdServerUrl + 'connect/authorize',
            redirectUri: window.location.protocol + "//" + window.location.host + "/",
            scopes: ['bdkalk']
        });
  
        var oldToken : ClientOAuth2.Token | null = null

        // Recovering token
        var tokenQuest = sessionStorage.getItem("token")
        
        if (tokenQuest && tokenQuest.length > 0) {
            // alert("found an old token, generating it again...")
            oldToken  = this.m_auth.createToken('access token', JSON.parse(tokenQuest))
        }
        else {
            // alert("Did not find any earlier token")
        }

        this.m_core = new BDKalkCore(this.ServerUrl, this.IdServerUrl)
        this.m_core.ConnectApp(this)
        this.m_scrollHeightEdit = 0
        this.m_recentSearchInput = ""
        document.addEventListener("keydown", e => this.OnKeyDown(e.key))
        document.addEventListener("keyup", e => this.OnKeyUp(e.key))
        document.addEventListener("scroll", e => this.OnScroll(e))
        window.addEventListener("resize", e => this.OnResize(e))
        
        // If redirected from logon page, process the access token
        if ((location.hash.indexOf("access_token") > 0) || (oldToken)) {
            
            if (oldToken) {
                this.GetCore().InitiateSelectionSetManager(oldToken)
                this.state.accessToken = oldToken

                const pricelistId = new URLSearchParams(location.search).get('pricelistId');
                if (location.hash.indexOf("access_token") > 0) {
                    // Clear the address bar
                    history.replaceState("", document.title, window.location.pathname); // window.location.search);
                }
                var Httpreq = new XMLHttpRequest(); // a new request
                Httpreq.open("GET", this.ServerUrl + "api/user");
                Httpreq.setRequestHeader("Authorization", "Bearer " + oldToken.accessToken);
                Httpreq.onload = () => {
                    const userinfo = JSON.parse(Httpreq.responseText) as UserInfo;
                    this.GetCore().LogIn(userinfo.name, userinfo.email || "Email address not set", userinfo.roleID)

                    if (this.m_core.GetLoggedInName() != null && pricelistId != null) {
                        this.m_core.SetDefaultPriceBook(pricelistId)
                    }
                }

                Httpreq.send();
            }
            else {
                this.m_auth.token.getToken(window.location).then(token => {
                    // Save the access token
                    this.GetCore().InitiateSelectionSetManager(token)
                    this.setState({ accessToken: token });
                    
                    try {
                        sessionStorage.setItem("token", JSON.stringify(token.data))
                    }

                    catch (e) {
                        alert("Failure to stringify the access token")
                    }

                    const pricelistId = new URLSearchParams(location.search).get('pricelistId');

                    // Clear the address bar
                    history.replaceState("", document.title, window.location.pathname + decodeURIComponent(token.data.state || "")); // window.location.search);
                    var Httpreq = new XMLHttpRequest(); // a new request
                    Httpreq.open("GET", this.ServerUrl + "api/user");
                    Httpreq.setRequestHeader("Authorization", "Bearer " + token.accessToken);
                    Httpreq.onload = () => {
                        const userinfo = JSON.parse(Httpreq.responseText) as UserInfo;
                        this.GetCore().LogIn(userinfo.name, userinfo.email || "Email address not set", userinfo.roleID)

                        if (this.m_core.GetLoggedInName() != null && pricelistId != null) {
                            this.m_core.SetDefaultPriceBook(pricelistId)
                        }
                    }

                    Httpreq.send();
                });
            }
        }
    }
    
    // ToggleExtInfo toggles the visibility of the extended info sidebar
    ToggleExtInfo() {
        this.setState({ ExtInfoUp: !this.state.ExtInfoUp })
    }

    // Returning an ID string that tells what artice, project or build part is currently selected
    GetSelectionID() {
        return this.state.selectionID
    }
    
    // Returns a reference to the currently selected article.
    GetSelectedArticle() {
        var art = this.m_core.GetPresentlySelectedArticle()

        if (art != null) {
            return art
        }

        var articleType = "undefined"
        
        if (this.state.DisplayMode == this.DMode.Favorites) {
            articleType = "displayed"
        }

        if (this.state.DisplayMode == this.DMode.NobbGroup) {
            articleType = "displayed"
        }

        if (this.state.DisplayMode == this.DMode.SearchResult) {
            articleType = "displayed"
        }
        
        if (articleType == "displayed"){
            var articles = this.m_core.GetDisplayedArticles()

            if (articles != null) {
                for (var i = 0; i < articles.length; i++) {
                    if (articles[i].GetSelectionLabel() == this.state.selectionID) {
                        return articles[i]
                    }
                }
            }

            return null
        }
        
        if (this.state.DisplayMode == this.DMode.QReport) {
            var articles = this.m_core.GetSelectedArticles()

            if (articles != null) {
                for (var i = 0; i < articles.length; i++) {
                    if (articles[i].GetSelectionLabel() == this.state.selectionID) {
                        return articles[i]
                    }
                }
            }

            return null
        }

        return null
    }
    
    // GetCore gives access to the core
    GetCore() {
        return this.m_core
    }

    // GetTreeView provides access to the tree view control object
    GetTreeView() {
        return this.m_core.GetTreeView()
    }

    // GetArticleView provides access to the article view control object
    GetArticleView() {
        return this.m_core.GetArticleView()
    }

    // (Temporary method for requesting json article files - will be replaced with access to real data)
    setArticlesPageUrl(newUrl: string) {
        var url = newUrl
        this.m_core.InactivateInputs()
        this.setState({ DisplayMode: this.DMode.Url, articlesUrl: url })
    }

    // Sets the display mode and other stats to show the contents of a selected nobb tree item
    setArticlesPageNobb(nobbGroup: string) {
        PADebug.Log("app.setArticlesPageNobb - nobbgroup:" + nobbGroup)
        var dMode = this.DMode.NobbGroup

        if (this.m_core.isGroupLoaded(nobbGroup) == false) {
            dMode = this.DMode.Loading
        }
        
        this.m_core.InactivateInputs()
        this.m_core.SetLastSelectedNobbGroup(nobbGroup)
        this.setState({ DisplayMode: dMode, articlesNobb: nobbGroup, resultGroup: 0, resultGroupStart: 0 })
    }

    // setArticlesPageSearch sets everything up for showing search results properly
    setArticlesPageSearch() {
        this.m_core.InactivateInputs()
        this.setState({ DisplayMode: this.DMode.SearchResult, resultTotalArticles: this.GetCore().GetDisplayedArticles().length, resultGroup: 0, resultGroupStart: 0 })
        this.GetCore().GetArticleView().forceUpdate()
    }

    // setArticlesPageFavorites sets everything up for showing favorites properly
    setArticlesPageFavorites() {
        this.m_core.InactivateInputs()
        this.setState({ DisplayMode: this.DMode.Favorites, resultTotalArticles: this.GetCore().GetFavorites().length, resultGroup: 0, resultGroupStart: 0 })
        this.GetCore().GetArticleView().forceUpdate()
    }

    // setArticlesPageFavorites sets everything up for showing favorites properly
    setArticlesPageBuildParts() {
        this.m_core.InactivateInputs()
        this.setState({ DisplayMode: this.DMode.byggdelLoad, resultTotalArticles: this.GetCore().GetBuildParts().length, resultGroup: 0, resultGroupStart: 0 })
        this.GetCore().GetArticleView().forceUpdate()
    }

    // setArticlesPageFavorites sets everything up for showing favorites properly
    setArticlesPageSelection() {
        this.m_core.InactivateInputs()
        this.setState({ DisplayMode: this.DMode.QReport, resultTotalArticles: (this.GetCore().GetSelectedArticles().length + this.GetCore().GetSelectedBuildParts().length), resultGroup: 0, resultGroupStart: 0 })
        this.GetCore().GetArticleView().forceUpdate()
    }

    // Selection of a prize book (by the dropbox at the top left)
    private changePricelist(liste: Prisliste) {
        this.Debug("app.changePricelist ")
        // this.setPrizeBook(liste.Tittel)
    }

    // Displaying info in a popup message if currently in debug mode
    Debug(message: string) {
        PADebug.Debug(message) 
    }

    // Displays the project save interface on the right hand side
    OnSaveProject() {
        this.setState({ DisplayMode: this.DMode.projectSave })
    }
    
    // Displays the project save interface on the right hand side
    OnSaveByggdel() {
        this.setState({ DisplayMode: this.DMode.byggdelSave })
    }
    
    // Handler for reseting height of displayed contents to automatic
    onDefaultScrollBar() {
        this.setState({ viewHeight: -1 })
    }

    // Handler for seting the height of displayed contents to a chosen value
    onSetScrollBar() {
        this.setState({ viewHeight: this.m_scrollHeightEdit })
    }

    // sets the height of the window contents to a value given by the user
    onChangeHeight(input: string) {
        var inputValue = 0

        if (input.length == 3) {
            inputValue += this.charValue(input[2])
            inputValue += this.charValue(input[1]) * 10
            inputValue += this.charValue(input[0]) * 100
        }

        if (input.length == 4) {
            inputValue += this.charValue(input[3])
            inputValue += this.charValue(input[2]) * 10
            inputValue += this.charValue(input[1]) * 100
            inputValue += this.charValue(input[0]) * 1000
        }
        
        if (inputValue >= 250){
            this.m_scrollHeightEdit = inputValue
        }
    }

    private m_scrollHeightEdit: number // value kept for seting the maximum height of the displayed contents, so that the scrollbars will work better on some clients

    IsArticleSelected(articleLabel: string) {

        if (this.state.selectionID == articleLabel) {
            return true
        }
        
        return false
    }

    // Will display a selection of articles or favorites list or scrollbar settings 
    RenderDisplaySection() {
        PADebug.Log("app.RenderDisplaySection - articlesUrl:" + this.state.articlesUrl + " articlesNobb:" + this.state.articlesNobb )
        return <ArticleViewGW height="" width="" initialUrl={this.state.articlesUrl} initialNobb={this.state.articlesNobb} app={this} />
    }

    /* When an item is clicked at the amount Input, this will cause a slightly delayed
     * focus to be performed upon it, so that it will first get its time to become re-rendered as
     * an input field, before recieving the focus, because the input field doesn't allready
     * exist when the user clicks on the amount field, by then it is just a text showing the amount,
     * just like all the other amount fields and which doesn't have the proper ID to recieve the focus. */
    ReFocus(inMilliseconds: number) {
        setTimeout(function ho() {
            var foc = document.getElementById("inputToBeFocusedOn")
            if (foc != null) {
                foc.focus()
            }

        }, inMilliseconds)
    }

    // Making sure the search imput gets focus when the search field gets clicked
    searchFieldClickHandler() {
        this.m_core.SetFocusOnSearchInput()

        setTimeout(function ho() {
            var foc = document.getElementById("searchField")
            if (foc != null) {
                foc.focus()
            }

        }, 340)
    }

    // GetLogin returns the graphics showing who's presently logged in
    GetLogin() {
        if (this.m_core.GetLoggedInName() == null) {
            return <div></div>
        }
        else {
            return <div style={{ width: "290px", height: '33px', display: 'flex', flexDirection: 'column' }
            }>
                <div style={{ height: "50%", width: "100%", display: 'flex', flexDirection: 'row' }}>
                    <div style={{ height: "100%", color: "#5969B9", position: "relative", top: "2px", fontSize:"12px" }}>
                        Pålogget som:
                    </div>
                </div>
                <div style={{ height: "50%", width: "100%"}}>
                    <div style={{ height: "100%", color: "#293949", fontSize: "12px", position: "relative", top: "3px" }}>
                        {this.m_core.GetLoggedInName()}
                    </div>
                </div>
            </div >
        }
    }
    
    // GetLogin returns the graphics showing who's presently logged in
    GetActiveProject() {
        var projectName = this.m_core.GetSelectionSetManager().GetCurrentProjectName()

        if (projectName == "") {
            return <div></div>
        }
        else {
            return <div style={{ width: "290px", height: '33px', display: 'flex', flexDirection: 'column' }
            }>
                <div style={{ height: "50%", width: "100%", display: 'flex', flexDirection: 'row' }}>
                    <div style={{ height: "100%", color: "#5969B9", position: "relative", top: "2px", fontSize: "12px" }}>
                        Utvalg:
                    </div>
                </div>
                <div style={{ height: "50%", width: "100%" }}>
                    <div style={{ height: "100%", color: "#293949", fontSize: "12px", position: "relative", top: "3px" }}>
                        {projectName}
                    </div>
                </div>
            </div >
        }
    }

    // returns the graphic link for logging in or out (depending on status)
    GetLogChange() {
        if (this.m_core.GetLoggedInName() == null) {

            return <div onClick={this.LogIn.bind(this)}  style={{ fontVariant: "underlined", width: "110px", position: "relative", color: "#5969B9", top: "6px", left: "-6px", cursor: "pointer" }}>
                <u>logg på</u>
            </div>
        }
        else {
            return <div onClick={this.LogOut.bind(this)} style={{ fontVariant: "underlined", width: "110px", position: "relative", color: "#5969B9", top: "6px", left: "-6px", cursor: "pointer" }}>
                <u>logg ut</u>
            </div>

            /* // Earlier and redirected logout method
                <a href={this.IdServerUrl + "Account/Logout"} target="_blank" style={{ color: "#5969B9"}}>
                    <u>logg ut</u>
                </a>
            */
        }
    }

    // Handler for logout calls
    LogOut() {
        sessionStorage.clear()
        this.m_core.LogOut();
        // location.href = "http://idbyggdata.azurewebsites.net/Account/Logout"
        // location.href = "http://idbyggdata.azurewebsites.net/"
    }

    // Handler for login calls (needs to be improved when backend part is available)
    LogIn() {
        // Redirects the user to the BDid login page
        this.m_core.SetLoginCalled(true)
        location.href = this.m_auth.token.getUri({ state: encodeURIComponent(location.search) });
        this.forceUpdate()
    }

    // Access to current search input value
    GetCurrentSearchInputValue() {
        if (this.m_searchInput) {
            return this.m_searchInput.value
        }

        return ""
    }

    // Handling key inputs in the search field
    searchFieldKeyHandler(enteredKey: string) {
        this.GetCore().StartSearchBeat(this.m_searchInput.value)
    }
    
    // Handling key inputs in the search field
    searchCathegoryClickHandler() {
        this.setState({cathegoricSearch: !this.state.cathegoricSearch})
    }

    // Handler for general keyboard typings
    OnKeyDown(key: string) {
        this.GetCore().HandleKeyDown(key)
    }

    // Handler for general keyboard typings
    OnKeyUp(key: string) {
        this.GetCore().HandleKeyUp(key)
    }

    // Scroll event handler
    OnScroll(event: any) {
        if (this.m_scrollToTopButton) {
            this.m_scrollToTopButton.forceUpdate()
        }
    }

    // Updates the reference to the most resently generated scroll button
    BindScrollToTopButton(button: ScrollToTopButton) {
        this.m_scrollToTopButton = button
    }

    // Returns a string telling how many percentage of the data has been loaded, with two decimals
    GetLoadPercentage() {
        var lo = ""
        var perc = this.GetCore().GetLoadPercentage()
        var ad = (perc * 100.0).toString()

        if (perc == 1.5) {
            // No groups were found under the examined group name (which may occur when changing pricebook)
            return "none"
        }

        var decims = 0

        for (var i = 0; i < ad.length; i++) {
            if (ad.charAt(i) == '.') {
                decims = 1
                lo += ","
            }
            else {
                if (decims == 0) {
                    lo += ad.charAt(i)
                }
                else {
                    if (decims == 3) {
                        lo += "%"
                        break
                    }
                    else {
                        decims++
                        lo += ad.charAt(i)
                    }
                }
            }
        }

        return lo
    }

    // Global click handler
    onClick() {
        setTimeout(this.ReFocus.bind(this), 100)
    }
    
    // Renders the entire BDKalk page
    render() {
        if (this.m_core.GetLoggedInName() == null) {
            if ((this.m_core.HasCalledForLogin() == true) || (this.state.accessToken != undefined)) {
                return <div>
                    <div className="pageSection" style={{ height: "34px", width: "100%", display: "flex", flexDirection: "row", backgroundImage: "url(images/HeaderColorV2.png)" }}>
                        <img src="images/HeaderBDKalkV5.png" alt="(BDKalk image)" height="34" width="170" />
                    </div>

                    <h2 style={{fontSize:"20px", marginLeft:"20px", marginTop:"20px"}} >Åpner prisassistenten...</h2>
                </div>
            }
            else {
                this.LogIn()
                return <div>Åpner innlogg side..</div>
            }
        }

        if (this.m_core.isInitiated() == false) {
            this.m_core.SetLoadBarMounted(false) // blocks any attempts by the loading procedure to update a non mounted (nor created in this case) load bar
            return <div id="appWindow">
                <div className="pageSection" style={{ height: "34px", width: "100%", display: "flex", flexDirection: "row", backgroundImage: "url(images/HeaderColorV2.png)" }}>
                    {/*   ByggData Logo   */}
                    <a href="http://byggdata.no/" target="_blank">
                        <ImageButton FilenameBase="HeaderLogo" TooltipText="Byggdata.no" Width="53" Height="34" app={this} buttonID="byggData" />
                    </a>
                    {/*   BDKalk   */}
                    <img src="images/HeaderBDKalkV5.png" alt="(BDKalk image)" height="34" width="170" />
                </div>
                <div style={{ position: "relative", left: "5px", top: "4px" }}>Innhenter data...</div>
           </div>
        }
        
        const app = this
        var ExtInfoHeight = this.state.ExtInfoUp ? "300px" : "0px"

        var viewHeight = ""
        if (this.state.viewHeight == -1) {
            viewHeight = "calc(100vh - 3px)"
        }
        else {
            viewHeight = "calc(" + this.state.viewHeight + "px - 3px)"
        }
        
        var buildPartToolButton: JSX.Element | null = <ToolbarButton app={this} imageNR={21} buttonID="henteByggdel" tooltipText="Bygningsdeler" />

        var helpButton: JSX.Element | null = <ToolbarButton app={this} imageNR={23} buttonID="help" tooltipText="Info og hjelp" />
        
        if (this.m_core.IsBuildpartsOn() == false) {
            buildPartToolButton = null
        }

        var debugInfoButton: JSX.Element | null = null
        var debugActionButton: JSX.Element | null = null
        var creationViewButton: JSX.Element | null = null
        var logViewButton: JSX.Element | null = null
        
        if (PADebug.IsDebuging() == true) {
            debugInfoButton = <ToolbarButton app={this} imageNR={22} buttonID="debugInfo" tooltipText="Debug info" />
            debugActionButton = <ToolbarButton app={this} imageNR={24} buttonID="debugAction" tooltipText="Debug action" />
            creationViewButton = <ToolbarButton app={this} imageNR={25} buttonID="creationView" tooltipText="test side" />
            logViewButton = <ToolbarButton app={this} imageNR={26} buttonID="showLog" tooltipText="Vis logg" />
        }
        
        // Adjusting the width of the total sum display in case it holds a high number and need to become wider.
        var totSumWidth = 280
        var totSumPotence = 100
        var sumBase = this.GetCore().TotalSum()

        while (sumBase > totSumPotence) {
            totSumPotence *= 10
            totSumWidth += 12
        }
        
        var totalSumWidthStr = totSumWidth.toString() + "px"

        var QRTabMinWidth = "153px"
        if (this.state.DisplayMode == this.DMode.QReport) {
            QRTabMinWidth = "0px"
        }

        var selectionQR = this.GetCore().GetSelectedArticles()
        if (selectionQR == null) {
            QRTabMinWidth = "0px"
        }
        else {
            if (selectionQR.length == 0) {
                QRTabMinWidth = "0px"
            }
        }
        
        return <div onKeyDown={e => this.OnKeyDown(e.key)}
            onClick={e => this.onClick()}
                    style={{
                        width: "calc(100vw - 17px)"
                    }}>
            
            <div style={{ width: "100%", minWidth: "704px" }}>
                {/* Title section margin */}
                <div style={{ height: "68px", width: "100%" }}>margin
                </div>
                {/* Main Body */}
                <div className="pageSection" style={{ display: "flex", flexDirection: "row", height: "calc(100% - 34px)", width: "100%" }}>
                    <div className="pageSection" style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>
                        {/*   Main Search Section   */}
                        <div className="pageSection" style={{ display: "flex", flexDirection: "row", height: "calc(100% - 34px)", width: "100%" }}>
                            {/*   Tree Section   */}
                            <div style={{ height: "100%", width: "33%", maxWidth: "430px", minWidth: "278px", borderRight: "1px solid #D9D9D9", borderTop: "1px solid #D9D9D9" }}>
                                {/*   Tree Section title (select)   */}
                                <div style={{ height: '43px', display: 'flex', flexDirection: 'row', width: '100%' }} >
                                    <h4 style={{ padding: '8px' }} >Prisbok</h4>
                                    <Prislister selectedID={this.GetCore().GetSelectedPriceBookID()} OnChangePricelist={l => this.changePricelist(l)} app={this} contentString={this.GetCore().GetContentStringForPrislister()} changeHandler={this.GetCore().SetPricebook.bind(this.GetCore())} />
                                    <NobbAlphaButton app={this} tooltipText="Nobb/Alfabetisk visning" buttonID="nobbAlpha"/>
                                </div>
                                {/*  ( Tree Section Contents )  */}
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                    <TreeViewGW defaultUrl="items/prizeBooks/book_optimera_alfabetisk.json" itemWidth="100%" itemHeight="33px" app={app} defaultExpanded={false} />
                                </div>
                                {// Debug display
                                    this.GetCore().RenderDebugDisplay()
                                }
                            </div>
                            {/*   Articles Section   */}
                            <div className="pageSection" style={{ height: "100%", width: "67%", minWidth: "calc(100% - 430px)", display: "flex", flexDirection: "column", borderTop: "1px solid #D9D9D9" }}>
                                {this.RenderArticleSection()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*   Titlebar   */}
            <div style={{ height: "34px", width: "calc(100vw - 17px)", minWidth: "704px", position: "fixed", top: "0px", left: "0px" }}>
                {/*   Header + RightSide   */}
                <div className="pageSection" style={{ height: "34px", width: "calc(100vw - 17px)", minWidth: "720px", display: "flex", flexDirection: "row-reverse", backgroundImage: "url(images/HeaderColorV2.png)" }}>
                    {/*   RightSide   */}
                    <div style={{ height: "34px", width: totalSumWidthStr, display: "flex", flexDirection: "row-reverse" }}>
                        <TotalDisplayGW app={this} />
                    </div>
                    <ImageButton FilenameBase="HeaderFavorites" TooltipText="Favoritter" Width="85" Height="34" app={this} buttonID="favorites" />
                    <div style={{ position: "relative", left: "74px", top: "2px", textAlign: "center", width: "30px" }} >{this.GetCore().GetFavoritesAmount()}
                    </div>
                    {/*   Header (left)   */}
                    <div className="pageSection" style={{ height: "34px", width: "calc(100% - 200px)", display: "flex", flexDirection: "row", backgroundImage: "url(images/HeaderColorV2.png)" }}>
                        {/*   ByggData Logo   */}
                        <a href="http://byggdata.no/" target="_blank">
                            <ImageButton FilenameBase="HeaderLogo" TooltipText="Byggdata.no" Width="53" Height="34" app={this} buttonID="byggData" />
                        </a>

                        {/*   BDKalk   */}
                        <img src="images/HeaderBDKalkV5.png" alt="(BDKalk image)" height="34" width="135" />
                        <div style={{ width: "35px", color: "#F1FFFF", position: "relative", top: "15px", left: "-10px", fontSize: "12px", fontStretch: "condensed", fontWeight: "bolder" }}>{this.GetCore().GetSelectionSetManager().GetVersionDisplayString()}
                        </div>
                        <SearchField app={this} />
                    </div>
                </div>
            </div>

            {/*   Toolbar   */}
            <div style={{ height: "34px", width: "calc(100vw - 17px)", minWidth: "704px", backgroundColor: "#f0f0f0", position: "fixed", top: "34px", left: "0px" }}>
                <div style={{ display: "flex", flexDirection: "row", width: "100%", height: "34px" }}>
                    <div style={{ display: "flex", flexDirection: "row", height: "34px", width: "calc(100% - 60px)", backgroundColor: "#f0f0f0" }}>

                        <ToolbarButton app={this} imageNR={7} buttonID="toolbarNew" tooltipText="Nytt utvalg (nullstill)" />
                        <ToolbarButton app={this} imageNR={9} buttonID="henteUtvalg" tooltipText="Hente utvalg" />
                        <ToolbarButton app={this} imageNR={16} buttonID="lagreUtvalg" tooltipText="Lagre utvalg" />

                        <div style={{ width: "15px" }}> </div> {/* Separation margin */}

                        <ToolbarButton app={this} imageNR={15} buttonID="hurtigRapport" tooltipText="Skriv ut utvalg" />
                        <ToolbarButton app={this} imageNR={6} buttonID="priceSettings" tooltipText="Prisvalg" />
                        <ToolbarButton app={this} imageNR={5} buttonID="utvidetInfo" tooltipText="Utvidet vareinformasjon" />
                        <ToolbarButton app={this} imageNR={2} buttonID="settings" tooltipText="Instillinger" />

                        <div style={{ width: "15px" }}> </div> {/* Separation margin */}

                        {buildPartToolButton}
                        {helpButton}

                        <div style={{ width: "35px" }}> </div> {/* Debug separation margin */}

                        {debugInfoButton}
                        {debugActionButton}
                        {creationViewButton}
                        {logViewButton}
                
                    </div>
                    {this.GetActiveProject()}
                    {this.GetLogin()}
                    {this.GetLogChange()}
                    <ExtTabGW app={this} buttonID="UtvidetInfoTab" />
                    <div style={{ minWidth: QRTabMinWidth, height:"34px" }}>
                        <QReportTabGW app={this} buttonID="QReportTab" />
                    </div>
                </div>

                {/* Scroll to top button */}
                <ScrollToTopButton app={this} />
            </div>
        </div>
    }

    // Takes focus away from all components
    BreakFocus() {
        this.GetCore().ClearInput(7)
    }

    // Scrolls all the way up
    ScrollToTop() {
        this.m_core.ClearFocus()
        scroll(0, 0)
    }
    
    // Renders the search result orientation buttons (located above and below the search results)
    RenderDisplaySectionGroupControls(isFooter: boolean) {
        var totalSource = this.state.resultTotalArticles

        var hits = " treffer"
        var noHits = "(Ingen treff)"

        if (this.state.DisplayMode == this.DMode.Favorites) {
            hits = " favoritter"
            noHits = "(Ingen favoritt funnet)"
        }

        if (this.state.DisplayMode == this.DMode.QReport) {
            hits = " utvalgte varer/bygningsdeler"
            noHits = "(Ingen vare/bygningsdel er valgt)"
        }

        if (this.state.DisplayMode == this.DMode.byggdelLoad) {
            hits = " bygningsdeler"
            noHits = "(Ingen bygningsdel funnet)"
        }

        if (this.state.DisplayMode == this.DMode.projectLoad) {
            hits = " lagrede utvalg"
            noHits = "(Inget utvalg funnet)"
        }

        if (isFooter == true) {
            noHits = ""
        }

        if (this.state.DisplayMode == this.DMode.Favorites) {
            var fa = this.m_core.GetFavorites()

            if (fa != null) {
                totalSource = this.m_core.GetFavorites().length
            }
        }
        
        const total = totalSource
        const step = this.state.resultGroupLength
        const lastSize = total % step
        const groups = ((total - lastSize) / step) + ((lastSize != 0) ? 1 : 0)
        const range = this.state.resultGroupRange

        var testInfo = "Viser " + ((this.state.resultGroup * step) + 1).toString() + "-" + ((((this.state.resultGroup + 1) * step) < total) ? ((this.state.resultGroup + 1) * step) : total).toString() + " av " + total.toString() + hits
        if (total == 0) {
            testInfo = noHits
        }
        
        if (groups < 2) {
            if (isFooter == false) {
                return <div>{testInfo}</div>
            }
            else {
                return <div></div>
            }
        }
        else {
            if (groups < range) {
                return <div>
                    {testInfo}
                    <div style={{ display: "flex", direction: "row" }}>
                        {this.RenderDisplaySectionNumericalButton(0)}
                        {this.RenderDisplaySectionNumericalButton(1)}
                        {this.RenderDisplaySectionNumericalButton(2)}
                        {this.RenderDisplaySectionNumericalButton(3)}
                        {this.RenderDisplaySectionNumericalButton(4)}
                        {this.RenderDisplaySectionNumericalButton(5)}
                        {this.RenderDisplaySectionNumericalButton(6)}
                        {this.RenderDisplaySectionNumericalButton(7)}
                        {this.RenderDisplaySectionNumericalButton(8)}
                        {this.RenderDisplaySectionNumericalButton(9)}
                    </div>
                </div>
            }
            else {
                return <div>
                    {testInfo}
                    <div style={{ display: "flex", direction: "row" }}>
                        < OrientationButton FilenameBase="selectionSplitButtons" TooltipText="Til begynnelsen" Width="34" Height="29" app={this} buttonID="allBack" buttonBaseOffset={0} buttonText="" position={-1} active={this.state.resultGroup != 0} />
                        < OrientationButton FilenameBase="selectionSplitButtons" TooltipText="Tilbake ti skritt" Width="32" Height="29" app={this} buttonID="rewind" buttonBaseOffset={34} buttonText="" position={-1} active={this.state.resultGroup != 0} />
                        < OrientationButton FilenameBase="selectionSplitButtons" TooltipText="Tilbake et skritt" Width="31" Height="29" app={this} buttonID="backward" buttonBaseOffset={66} buttonText="" position={-1} active={this.state.resultGroup != 0} />
                        {this.RenderDisplaySectionNumericalButton(0)}
                        {this.RenderDisplaySectionNumericalButton(1)}
                        {this.RenderDisplaySectionNumericalButton(2)}
                        {this.RenderDisplaySectionNumericalButton(3)}
                        {this.RenderDisplaySectionNumericalButton(4)}
                        {this.RenderDisplaySectionNumericalButton(5)}
                        {this.RenderDisplaySectionNumericalButton(6)}
                        {this.RenderDisplaySectionNumericalButton(7)}
                        {this.RenderDisplaySectionNumericalButton(8)}
                        {this.RenderDisplaySectionNumericalButton(9)}
                        < OrientationButton FilenameBase="selectionSplitButtons" TooltipText="Fremover et skritt" Width="31" Height="29" app={this} buttonID="forward" buttonBaseOffset={97} buttonText="" position={-1} active={(this.state.resultGroup + 1) < groups} />
                        < OrientationButton FilenameBase="selectionSplitButtons" TooltipText="Fremover ti skritt" Width="31" Height="29" app={this} buttonID="fastForward" buttonBaseOffset={128} buttonText="" position={-1} active={(this.state.resultGroup + 1) < groups} />
                        < OrientationButton FilenameBase="selectionSplitButtons" TooltipText="Til sluttet" Width="33" Height="29" app={this} buttonID="toEnd" buttonBaseOffset={159} buttonText="" position={-1} active={(this.state.resultGroup + 1) < groups} />
                    </div>
                </div>
            }
        }
    }

    // Tells if this group of search results is the last one available
    GetIsLastGroup() {
        // Ignoring attemts to cross result groups on favorites since it (presently) has no such groups
        if (this.state.DisplayMode == this.DMode.Favorites) {
            return true
        }

        const total = this.state.resultTotalArticles
        const step = this.state.resultGroupLength
        const lastSize = total % step
        const groups = ((total - lastSize) / step) + ((lastSize != 0) ? 1 : 0)

        if ((this.state.resultGroup + 1) < groups) {
            return false
        }
        else {
            return true
        }
    }

    // Tells if this group of search results is the first one 
    GetIsFirstGroup() {

        if (this.state.resultGroup != 0) {
            return false
        }
        else {
            return true
        }
    }

    // Renders a single numerical search result orientation button
    RenderDisplaySectionNumericalButton(increment: number) {
        const total = this.state.resultTotalArticles
        const step = this.state.resultGroupLength
        const lastSize = total % step
        const groups = ((total - lastSize) / step) + ((lastSize != 0) ? 1 : 0)
        const range = this.state.resultGroupRange
        const thisPos = this.state.resultGroupStart + increment
        
        var isSelected = (thisPos == this.state.resultGroup) ? true : false
        var graphicsOffset = isSelected ? 228 : 195

        var tooltip = "resultater fra " + ((thisPos * step)+1).toString() + " til " + ((thisPos + 1) * step).toString()
        var buttonText = (thisPos + 1).toString()

        // Out of range - returning an empty div instead
        if (thisPos >= groups) {
            return <div></div>
        }

        return <OrientationButton FilenameBase="selectionSplitButtons" TooltipText={tooltip} Width="31" Height="29" app={this} buttonID="numerical" buttonBaseOffset={graphicsOffset} buttonText={buttonText} position={thisPos} active={true} />
    }

    // Renders the Logotype image given for the selected pricebook (these have to first be placed as a .png image within the /images/pricebook/.. directory) 
    RenderPriceBookLogo() {
        var pricebook = this.GetCore().GetSelectedPriceBook();

        if (pricebook == null) {
            return <div style={{ display: "flex", direction: "row" }}>
                <div style={{ fontWeight:"bolder", fontSize:"19px", height: "40px", width: "225px", marginLeft: "22px", marginTop: "15px" }}>
                    <h2>Alle prisbøker:</h2>
                </div>

                {(this.state.DisplayMode != this.DMode.Loading) ? (this.RenderDisplaySectionGroupControls(false)) : (null)}
            </div>
        }
        else {
            const imageUrl = ("images/priceBook/" + pricebook.GetFileBase() + ".png")

            var priceBookTitle = " " + pricebook.GetTitle()

            if (priceBookTitle.charAt(priceBookTitle.length - 1) == ",") {
                priceBookTitle = priceBookTitle.slice(0, (priceBookTitle.length - 1))
            }

            var altTitleSize = 600 / (12 + priceBookTitle.length) 
            altTitleSize = altTitleSize - (altTitleSize % 1)
            const sizeStr = altTitleSize.toString() + "px"
            
            return <div style={{ display: "flex", direction: "row" }}>
                <img src={imageUrl} alt={priceBookTitle}
                    style={{
                        height: "40px",
                        width: "200px",
                        marginTop: "10px",
                        fontSize: sizeStr,
                        marginLeft: "12px",
                        fontWeight: "bold",
                        fontStretch: "condensed",
                        color: "#444444"
                    }} />

                <div style={{ width: "35px" }}>
                </div>

                {(this.state.DisplayMode != this.DMode.Loading) ? (this.RenderDisplaySectionGroupControls(false)) : (null)}
            </div>
        }
    }

    // Clearing the current search word from the search field and seting focus into it
    ResetSearchInput() {

        if (this.GetSearchInput() != null) {
            this.GetSearchInput().value = ""
        }

        this.m_recentSearchInput = ""

        this.m_core.UpdateSearchFieldTimed()

        if (this.state.cathegoricSearch == true) {
            var lastGroup = this.m_core.GetLastSelectedGroup()
            if (lastGroup != "") {
                this.m_core.RunSearch("", this.m_core.GetArticlesByGroup(lastGroup))
            }
            else {
                this.m_core.RunSearch("")
            }
        }
        else {
            this.m_core.RunSearch("")
        }
    }

    // 
    RenderQuickReportTitle() {
        return <div>
            {/* Margin */}
            <div style={{ height: "5px" }}></div>

            <div className="pageSection" style={{ height: "26px", width: "100%", display: "flex", flexDirection: "row", borderTop: "1px solid #B9B9B9", borderBottom: "1px solid #B9B9B9", font: "bold" }}>
                <div style={{ width: "14px", height: "1px" }} ></div>

                {/* Numeric control area title part */}
                <div style={{ width: "120px", position: "relative", left: "20px", top: "6px" }} >
                    Antall
                </div>

                {/* Ext Info arrowdown area title part */}
                <div style={{ width: "20px" }} >
                </div>

                {/* Central dynamic columns area title part */}
                <div style={{ width: "calc(100% - 148px)", display: 'flex', flexDirection: 'row' }} >
                    <div style={{ width: "1%", position: "relative", top: "6px" }}></div>
                    <div style={{ width: "9%", position: "relative", top: "6px" }}>Enhet</div>
                    <div style={{ width: "33%", position: "relative", top: "6px" }}>Varetekst</div>
                    <div style={{ width: "31%", position: "relative", top: "6px" }}></div>
                    <div style={{ width: "13%", position: "relative", top: "6px" }}>Varenr.</div>
                    <div style={{ width: "calc(12% - 8px)", position: "relative", top: "6px", textAlign: "right" }}>Enh.pris</div>
                    <div style={{ width: "calc(12% - 8px)", position: "relative", top: "6px", textAlign: "right" }}>Sum</div>
                    <div style={{ width: "calc(1% + 8px)", position: "relative", top: "6px" }}></div>
                </div>

                {/* Favorites star area title part */}
                <div style={{ position: "relative", top: "6px", width: "32px" }} >Fav.
                </div>
            </div>
        </div>
    }
    
    // Renders the (right hand side) section where search results, cathegory contents, favorites or quick report contents are diplayed (depending on current statuses)
    RenderArticleSection() {

        if (this.state.DisplayMode == this.DMode.projectLoad) {
            // Listing and managing saved projects
            return < ProjectView app={this} />
        }

        if (this.state.DisplayMode == this.DMode.help) {
            // The help menu showing selectable help chapters
            return <HelpView app={this} />
        }

        if (this.state.DisplayMode == this.DMode.priceSettings) {
            // The "Prisvalg" view, where settings for unit prices can be changed
            return < PriceSettingsView app={this} />
        }
        
        if (this.state.DisplayMode == this.DMode.projectSave) {
            // Save view for projects
            return < ProjectSaveView app={this} />
        }

        if (this.state.DisplayMode == this.DMode.byggdelSave) {
            // Save view for build parts
            return < BuildPartSaveView app={this} />
        }

        if (this.state.DisplayMode == this.DMode.byggdelLoad) {
            // Build part listing and loading view
            return < BuildPartView app={this} />
        }

        if (this.state.DisplayMode == this.DMode.searchSettings) {
            // Rendering the search options page 
            return < SearchSettingsView app={this} />
        }

        if (this.state.DisplayMode == this.DMode.newProject) {
            // Rendering the search options page 
            return < NewProjectView app={this} />
        }

        // Deletion of articles from favorites:
        if (this.state.DisplayMode == this.DMode.FavoritesDelete) {
            // Rendering the search options page 
            var art = this.m_core.GetFavoritesDeletionArticle()
            if (art) {
                return < FavoritesDeleteView article={art} app={this} />
            }
            else {
                return <div> Error in app - no favorite was assigned as the favorite being deleted!</div>
            }
        }
        
        // Creation, debugging and testing page
        if (this.state.DisplayMode == this.DMode.creative) {
            // Rendering the creation page 

            return < CreationView app={this} core={this.GetCore()} />
        }
        
        if (this.state.DisplayMode == this.DMode.QReport) {

            var buildPartSaveButton: JSX.Element | null = <div onClick={this.OnSaveByggdel.bind(this)} style={{ height: "26px", width: "200px", position: "relative", top: "3px", backgroundColor: "grey" }}>
                <div style={{ color: "white", position: "relative", top: "2px", left: "8px", cursor: "pointer" }}>
                    Lagre som bygningsdel..
                            </div>
            </div>

            if (this.m_core.IsBuildpartsOn() == false) {
                buildPartSaveButton = null
            }

            const projName: string = this.GetCore().GetSelectionSetManager().GetCurrentProjectName()

            var projectTitle = <div></div>

            if (projName != null) {
                if (projName.length != 0) {
                    projectTitle = <h2 style={{ color: "#004488" }}>Utvalg: {projName}
                    </h2>
                }
            }

            // Rendering QuickReport Section
            return <div className="pageSection" style={{ width: "100%" }}>
                <div style={{ marginLeft: "35px", marginTop: "16px", display: "flex", flexDirection: "row" }}>
                    <div style={{ height: "30px", width: "100%", display: "flex", flexDirection: "row" }}>
                        <div style={{ width: "calc(100% - 400px)"}}>
                            {projectTitle}
                        </div>
                        <div onClick={this.OnSaveProject.bind(this)} style={{ height: "26px", width: "112px", position: "relative", top: "3px", backgroundColor: "grey" }}>
                            <div style={{ color: "white", position: "relative", top: "2px", left: "8px", cursor: "pointer"}}>
                                Lagre utvalg..
                            </div>
                        </div>
                        <div style={{width:"10px", height:"1px"}} ></div>
                        {buildPartSaveButton}
                        <div style={{ width: "10px", height: "1px" }} ></div>
                        <div onClick={this.OnClearQR.bind(this)} style={{ height: "26px", width: "98px", position: "relative", top: "3px", backgroundColor: "grey" }}>
                            <div style={{ color: "white", position: "relative", top: "2px", left: "8px", cursor: "pointer" }}>
                                Tøm utvalg
                            </div>
                        </div>
                        <div style={{ width: "4px", height: "1px" }} ></div>
                    </div>
                </div>
                <div style={{ marginLeft: "35px", marginTop: "10px", height:"75px" }}>
                    {this.RenderDisplaySectionGroupControls(false)}
                </div>

                {/*   QuickReport Body   */}
                <div className="pageSection" style={{ height: "calc(100% - 52px)", width: "100%" }}>
                    {/*  ( QuickReport Contents )  */}
                    <SelectionViewGW app={this} />
                </div>
            </div>
        }



        // Rendering orders enlisted, with pdf download access
        if (this.state.DisplayMode == this.DMode.renderOrders) {
            // Rendering QuickReport Section
            return < SummaryView app={this} />
        }
        
        // Checking if favorites are to be displayed
        if (this.state.DisplayMode == this.DMode.Favorites) {
            return <div className="pageSection" style={{ width: "100%" }}>

                <div style={{ display:"flex", direction:"row", marginLeft: "34px", marginTop: "16px" }}>
                    <h2>Favoritter:</h2>
                    <div style={{width:"45px"}}></div>
                    {this.RenderDisplaySectionGroupControls(false)}
                </div>

                {/*   Articles Title   */
                    this.RenderDisplaySectionTitle()
                }

                {/*   Articles Body   */}
                <div className="pageSection" style={{ width: "100%" }}>
                    {/*  ( Articles Section Contents )  */
                        this.RenderDisplaySection()
                    }
                </div>
                <div style={{marginLeft:"35px"}}>
                    {this.RenderDisplaySectionGroupControls(true)}
                </div>
            </div>
        }

        if ((this.state.DisplayMode == this.DMode.SearchResult) || (this.state.DisplayMode == this.DMode.NobbGroup)) {

            // Default - Rendering an articles page
            return <div>
                {this.RenderPriceBookLogo()}

                {/*   Articles Title   */
                    this.RenderDisplaySectionTitle()
                }

                {/*   Articles Body   */}
                <div className="pageSection" style={{ width: "100%" }}>
                    {/*  ( Articles Section Contents )  */
                        this.RenderDisplaySection()
                    }
                </div>
                <div style={{ marginLeft:"35px" }}>
                    {(((this.state.resultTotalArticles >= this.state.resultGroupLength) && (this.state.DisplayMode != this.DMode.Loading)) ? (this.RenderDisplaySectionGroupControls(true)) : (null))}
                </div>
            </div>
        }

        if (this.state.DisplayMode == this.DMode.Init) {
            // The right hand side area is just shown as a blank page, until the first user request has been made. 
            return <div></div>
        }

        if (this.state.DisplayMode == this.DMode.log) {
            // Showing log, this will only be available when run in debug mode
            return <LogView app={this}/>
        }

        if (this.state.DisplayMode == this.DMode.Loading) {
            if (this.m_core.GetLoadingTask() == "project") {
                return <LoadingView waitingFor={"project"} app={this} />
            }

            if (this.m_core.GetLoadingTask() == "buildPart") {
                return <LoadingView waitingFor={"buildPart"} app={this} />
            }

            // Showing a blank page while loading, a loading bar is shown at this time in the search input field showing the loading progress. 
            return <div></div>
        }
        
        // The current display mode was not supported (this should never happen)
        PADebug.Assert(false, "App.RenderArticleSection - unsupported displaymode")
        return <div></div>
    }

    // Will display the title area for the selection view (for common article display or for favorites display)
    RenderDisplaySectionTitle() {
        var favTitle = "Fav."
        if (this.state.DisplayMode == this.DMode.Favorites) {
            favTitle = "Fjern"
        }

        // Rendering the row of column titles for displayed articles
        return < div className="pageSection" style={{ height: "26px", width: "100%", display: "flex", flexDirection: "row", borderTop: "1px solid #B9B9B9", borderBottom: "1px solid #B9B9B9", font: "bold" }}>
            {/* Ext Info arrowdown area */}
            <div style={{ width:"35px"}}>
            </div>

            {/* Numeric control area */}
            <div style={{ width: "120px", position: "relative", left: "20px", top: "6px" }} >
                Antall
            </div>
            
            {/* Central dynamic columns area */}
            <div style={{ width: "calc(100% - 187px)", display: 'flex', flexDirection: 'row' }} >
                <div style={{ width: "1%", position: "relative", top: "6px" }}></div>
                <div style={{ width: "9%", position: "relative", top: "6px" }}>Enhet</div>
                <div style={{ width: "33%", position: "relative", top: "6px" }}>Varetekst</div>
                <div style={{ width: "31%", position: "relative", top: "6px" }}></div>
                <div style={{ width: "13%", position: "relative", top: "6px" }}>Varenr.</div>
                <div style={{ width: "calc(12% - 8px)", position: "relative", top: "6px", textAlign: "right" }}>Enh.pris</div>
                <div style={{ width: "calc(12% - 8px)", position: "relative", top: "6px", textAlign: "right" }}>Sum</div>
                <div style={{ width: "calc(1% + 8px)", position: "relative", top: "6px" }}></div>
            </div>

            {/* Favorites star area */}
            <div style={{ position: "relative", top: "6px", width: "32px" }} >{favTitle}</div>
        </div>
    }

    // OnClearQR empties the quick report from both selected articles and buildparts
    private OnClearQR() {
        this.setState({ DisplayMode: this.DMode.newProject })
    }

    // Access : Search input
    GetSearchInput() {
        return this.m_searchInput
    }

    // Access : Recent Search input
    GetRecentSearchInput() {
        return this.m_recentSearchInput
    }

    // Access : Recent Search input
    SetSearchInput(input: HTMLInputElement) {
        this.m_searchInput = input
    }
    
    // Access : Recent Search input
    SetRecentSearchInput(input: string) {
        this.m_recentSearchInput = input
    }
    
    // reuses the most recent search input to make the same call again (after for example a change in pricebook)
    public RePostSearchCall() {
        var input = this.m_recentSearchInput

        this.m_core.RunSearch(input, this.m_core.GetArticlesByGroup(this.m_core.GetLastSelectedGroup()))
    }

    // GetRoundedNumericString // Takes a value and reduce its excessive decimal accuracy and presents it as a string suited to be shown in numerical controls
    GetRoundedNumericString(value: number) {
        var decimalsMax = this.GetCore().Get_max_Shown_Decimal_Amount()
        var decimals = decimalsMax
        var factor = 1.0
        var greatness = 10
        var potence = 0

        for (var i = 0; i < 100; i++) {
            if (value >= greatness) {
                greatness *= 10
                potence++
            }
            else {
                break
            }
        }

        decimals -= potence

        if (decimals < 0) {
            decimals = 0
        }

        for (var i = 0; i < decimals; i++) {
            factor /= 10
        }

        value += factor/2

        var newValue = value - (value % factor)
        var newString = newValue.toString()
        var result = ""
        var passedComma = false
        var enteredDecimals = 0

        for (var i = 0; i < newString.length; i++) {
            if (newString.charAt(i) == ".") {
                passedComma = true

                if (decimals == 0) {
                    break
                }
                
                result += "."
                continue
            }
            
            if ((enteredDecimals >= decimals) && (passedComma == true)) {
                break
            }

            if (passedComma == true) {
                enteredDecimals++
            }

            result += newString.charAt(i)
        }

        var skippedZeroes = 0
        var confirmedSkips = 0
        var foundTheComma = false
        var interrupted = false

        for (var i = result.length - 1; (i >= 0) && (passedComma == true); i--) {
            if (result.charAt(i) == ".") {
                foundTheComma = true

                if (interrupted == false) {
                    skippedZeroes++
                }

                confirmedSkips = skippedZeroes
                break
            }

            if (result.charAt(i) != "0") {
                interrupted = true
            }

            if (interrupted == false) {
                skippedZeroes++
            }
        }

        var finalResult = ""

        for (var i = 0; i < (result.length - skippedZeroes); i++) {
            finalResult += result.charAt(i)
        }

        if (finalResult == "") {
            this.Debug("numerical error - skippedZeroes:" + skippedZeroes + " interrupted" + (interrupted == true ? "true" : "false") + " result:\"" + result + "\" decimals:" + decimals.toString() + " potence:" + potence.toString() + " value:" + value.toString() + " greatness:" + greatness.toString() + " newString:\"" + newString + "\"" )
        }

        return MakeNational(finalResult)
    }

    // Taking an entered string (from numerical controls) and transforms it into a number, or null if it's not any valid number (or negative which is not accepted here)
    ParseToPositiveNumber(input: string | null) {
        if (input == null) {
            return null
        }

        if (input.length < 1) {
            return null
        }

        var result = ""
        var resultDecimals = ""
        var passedComma = false

        for (var i = 0; i < input.length; i++) {
            if ((input[i] == '.') || (input[i] == ',')) {
                if (passedComma == true) {
                    return null
                }

                passedComma = true
                continue
            }

            if ((input[i] == '0') || (input[i] == '1') || (input[i] == '2') || (input[i] == '3')
                || (input[i] == '4') || (input[i] == '5') || (input[i] == '6') || (input[i] == '7')
                || (input[i] == '8') || (input[i] == '9')) {

                if (passedComma == true) {
                    resultDecimals += input[i]
                }
                else {
                    result += input[i]
                }
                continue
            }

            return null
        }

        var newAmount = 0.0

        // Adding the value of the full numbers
        var multiplyer = 1.0
        for (var d = (result.length - 1); d >= 0; d--) {
            newAmount += multiplyer * this.charValue(result[d])
            multiplyer *= 10
        }

        // Adding the value of the decimals
        multiplyer = 0.1
        for (var d = 0; d < resultDecimals.length; d++) {
            newAmount += multiplyer * this.charValue(resultDecimals[d])
            multiplyer /= 10
        }

        return newAmount
    }

    // converts a numeric value between 0 and 9 into a character
    charValue(character: string) {
        if (character == "1") {
            return 1
        }

        if (character == "2") {
            return 2
        }

        if (character == "3") {
            return 3
        }

        if (character == "4") {
            return 4
        }

        if (character == "5") {
            return 5
        }

        if (character == "6") {
            return 6
        }

        if (character == "7") {
            return 7
        }

        if (character == "8") {
            return 8
        }

        if (character == "9") {
            return 9
        }

        return 0
    }

    private m_scrollToTopButton: ScrollToTopButton
};




// WEBPACK FOOTER //
// ./client/view/app.tsx